import { API_METHODS } from 'constants/api-methods'
import { BASE_API_URL } from 'constants/env'
import { store } from 'index'
import toast from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { apiHeaders } from 'utils/api-headers'
import { organizationsKeys, workosOrganizationsKeys } from 'utils/query-keys'
import { ID } from 'utils/types'

const deleteDirectoryMapping = async ({
  orgId,
  directoryMappingId,
}: {
  orgId: ID
  directoryMappingId: ID
}) => {
  const response = await fetch(
    `${BASE_API_URL}/api/v3/organizations/${orgId}/directory_mappings/${directoryMappingId}`,
    {
      method: API_METHODS.DELETE,
      headers: apiHeaders(store.getState()),
    }
  )
  return response
}

const useDeleteDirectoryMapping = (orgId: ID) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ directoryMappingId }: { directoryMappingId: ID }) => {
      return deleteDirectoryMapping({ orgId, directoryMappingId })
    },
    {
      onSuccess: async (data, variables, context) => {
        toast('Directory Mapping Deleted', { icon: `👍` })

        await Promise.all([
          queryClient.invalidateQueries(
            organizationsKeys.directoryMappings.all
          ),
        ])
      },
      onError: (e, variables, context) => {
        console.error(e)
        alert(
          'Uh oh! There was an error! Check the console. Take a screenshot and send to engineers.'
        )
      },
    }
  )
}

export default useDeleteDirectoryMapping
